import { gql } from 'urql';
import { PRODUCT } from '../client';
import { GGetBulkItemsQuery } from '../types/generated';

export const GET_BULK_ITEMS = gql<GGetBulkItemsQuery>`
  query ${PRODUCT}GetBulkItems($input: WarehouseBulkPickedItemsInput!, $first: Int) {
    warehouseBulkPickedItems(input: $input, first: $first) {
      nodes {
        ... on InventoryItem {
          id
          name
        }
        ... on NonInventoryItem {
          id
          name
        }
      }
    }
  }
`;
